import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ID: ")
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "card card-accent-primary" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "내용", -1)
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "card card-accent-primary" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "태그", -1)
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "태그가 없습니다", -1)
const _hoisted_15 = { class: "card card-accent-primary" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "댓글", -1)
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, "Comment ID", -1)
const _hoisted_20 = { class: "col-md-10" }
const _hoisted_21 = {
  class: "form-control form-control-static",
  disabled: ""
}
const _hoisted_22 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, "내용", -1)
const _hoisted_23 = { class: "col-md-10" }
const _hoisted_24 = {
  class: "form-control form-control-static",
  disabled: ""
}
const _hoisted_25 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, "사용자명", -1)
const _hoisted_26 = { class: "col-md-10" }
const _hoisted_27 = {
  class: "form-control form-control-static",
  disabled: ""
}
const _hoisted_28 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, "Is report", -1)
const _hoisted_29 = { class: "col-md-10" }
const _hoisted_30 = {
  key: 0,
  class: "btn btn-danger",
  type: "button"
}
const _hoisted_31 = {
  key: 1,
  class: "btn paging-prev",
  type: "button"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, "숨김 여부", -1)
const _hoisted_33 = { class: "col-md-10" }
const _hoisted_34 = { class: "c-switch c-switch-pill c-switch-primary mt-1" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_36 = {
  key: 0,
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}
const _hoisted_37 = {
  key: 1,
  class: "col-md-10"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, [
  /*#__PURE__*/_createVNode("small", null, "Comment ID")
], -1)
const _hoisted_40 = { class: "col-md-10" }
const _hoisted_41 = {
  class: "form-control form-control-static",
  disabled: ""
}
const _hoisted_42 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, [
  /*#__PURE__*/_createVNode("small", null, "내용")
], -1)
const _hoisted_43 = { class: "col-md-10" }
const _hoisted_44 = {
  class: "form-control form-control-static",
  disabled: ""
}
const _hoisted_45 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, [
  /*#__PURE__*/_createVNode("small", null, "사용자명")
], -1)
const _hoisted_46 = { class: "col-md-10" }
const _hoisted_47 = {
  class: "form-control form-control-static",
  disabled: ""
}
const _hoisted_48 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, [
  /*#__PURE__*/_createVNode("small", null, "Is report")
], -1)
const _hoisted_49 = { class: "col-md-10" }
const _hoisted_50 = {
  key: 0,
  class: "btn btn-danger btn-sm",
  type: "button"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("small", null, "true", -1)
const _hoisted_52 = {
  key: 1,
  class: "btn btn-dark btn-sm",
  type: "button"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("small", null, "false", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("label", {
  class: "col-md-2 col-form-label",
  for: "disabled-input"
}, [
  /*#__PURE__*/_createVNode("small", null, "숨김 여부")
], -1)
const _hoisted_55 = { class: "col-md-10" }
const _hoisted_56 = { class: "c-switch c-switch-pill c-switch-primary mt-1" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", null, "댓글이 없습니다", -1)
const _hoisted_61 = { class: "card card-accent-primary" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "출조지", -1)
const _hoisted_63 = { class: "card-body content-center justify-content" }
const _hoisted_64 = { class: "mfe-5" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" 바다 ")
const _hoisted_66 = { class: "" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 민물")
const _hoisted_68 = { class: "card card-accent-primary" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "선호하는 낚시", -1)
const _hoisted_70 = { class: "card-body content-center justify-content" }
const _hoisted_71 = { class: "mfe-5" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" 바다낚시 ")
const _hoisted_73 = { class: "" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 민물낚시")
const _hoisted_75 = { class: "card card-accent-primary" }
const _hoisted_76 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "포인트 정보", -1)
const _hoisted_77 = { class: "card-body" }
const _hoisted_78 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "수정", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CImage = _resolveComponent("CImage")

  return (_openBlock(), _createBlock("div", {
    class: ["card", { loading: _ctx.loading }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h4", null, [
        _hoisted_2,
        _createVNode("strong", null, _toDisplayString(_ctx.postId), 1)
      ]),
      _createVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fishingGram.images, (image) => {
                return (_openBlock(), _createBlock("a", {
                  key: image,
                  href: image + '?w=800',
                  target: "_blank"
                }, [
                  _createVNode(_component_CImage, {
                    class: "mr-2",
                    rounded: "",
                    thumbnail: "",
                    src: `${image}?w=150`,
                    width: "150"
                  }, null, 8, ["src"])
                ], 8, ["href"]))
              }), 128))
            ]),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, [
                _createVNode("pre", null, _toDisplayString(_ctx.fishingGram.content), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, [
                (_ctx.fishingGram.tags.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_12, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fishingGram.tags, (item) => {
                        return (_openBlock(), _createBlock("span", {
                          key: item,
                          class: "badge badge-pill badge-primary"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_13, [
                      _hoisted_14
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("div", _hoisted_17, [
                (_ctx.fishingGram.comments.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fishingGram.comments, (item) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "form-group row mb-5",
                          key: item
                        }, [
                          _hoisted_19,
                          _createVNode("div", _hoisted_20, [
                            _createVNode("p", _hoisted_21, _toDisplayString(item.id), 1)
                          ]),
                          _hoisted_22,
                          _createVNode("div", _hoisted_23, [
                            _createVNode("p", _hoisted_24, _toDisplayString(item.comment), 1)
                          ]),
                          _hoisted_25,
                          _createVNode("div", _hoisted_26, [
                            _createVNode("p", _hoisted_27, _toDisplayString(item.nick_name), 1)
                          ]),
                          _hoisted_28,
                          _createVNode("div", _hoisted_29, [
                            (item.is_report)
                              ? (_openBlock(), _createBlock("button", _hoisted_30, " true "))
                              : (_openBlock(), _createBlock("button", _hoisted_31, " false "))
                          ]),
                          _hoisted_32,
                          _createVNode("div", _hoisted_33, [
                            _createVNode("label", _hoisted_34, [
                              _withDirectives(_createVNode("input", {
                                onChange: ($event: any) => (_ctx.blindHandler(item.id, $event)),
                                type: "checkbox",
                                class: "c-switch-input",
                                "onUpdate:modelValue": ($event: any) => (item.is_blind = $event)
                              }, null, 40, ["onChange", "onUpdate:modelValue"]), [
                                [_vModelCheckbox, item.is_blind]
                              ]),
                              _hoisted_35
                            ])
                          ]),
                          (item.child_comments.length)
                            ? (_openBlock(), _createBlock("label", _hoisted_36, "대댓글"))
                            : _createCommentVNode("", true),
                          (item.child_comments.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                                (item.child_comments.length)
                                  ? (_openBlock(), _createBlock("div", _hoisted_38, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.child_comments, (c_comment) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "form-group row",
                                          key: c_comment
                                        }, [
                                          _hoisted_39,
                                          _createVNode("div", _hoisted_40, [
                                            _createVNode("p", _hoisted_41, [
                                              _createVNode("small", null, _toDisplayString(c_comment.id), 1)
                                            ])
                                          ]),
                                          _hoisted_42,
                                          _createVNode("div", _hoisted_43, [
                                            _createVNode("p", _hoisted_44, [
                                              _createVNode("small", null, _toDisplayString(c_comment.comment), 1)
                                            ])
                                          ]),
                                          _hoisted_45,
                                          _createVNode("div", _hoisted_46, [
                                            _createVNode("p", _hoisted_47, [
                                              _createVNode("small", null, _toDisplayString(c_comment.nick_name), 1)
                                            ])
                                          ]),
                                          _hoisted_48,
                                          _createVNode("div", _hoisted_49, [
                                            (c_comment.is_report)
                                              ? (_openBlock(), _createBlock("button", _hoisted_50, [
                                                  _hoisted_51
                                                ]))
                                              : (_openBlock(), _createBlock("button", _hoisted_52, [
                                                  _hoisted_53
                                                ]))
                                          ]),
                                          _hoisted_54,
                                          _createVNode("div", _hoisted_55, [
                                            _createVNode("label", _hoisted_56, [
                                              _withDirectives(_createVNode("input", {
                                                onChange: ($event: any) => (_ctx.blindHandler(c_comment.id, $event)),
                                                type: "checkbox",
                                                class: "c-switch-input",
                                                "onUpdate:modelValue": ($event: any) => (c_comment.is_blind = $event)
                                              }, null, 40, ["onChange", "onUpdate:modelValue"]), [
                                                [_vModelCheckbox, c_comment.is_blind]
                                              ]),
                                              _hoisted_57
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_58
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_59, [
                      _hoisted_60
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_61, [
              _hoisted_62,
              _createVNode("div", _hoisted_63, [
                _createVNode("label", _hoisted_64, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    id: 'FISHING_PLACE_TYPE_SEA',
                    name: 'FISHING_PLACE_TYPE',
                    value: 'SEA',
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fishingGram.fishing_place_type = $event)),
                    checked: _ctx.fishingGram.fishing_place_type === 'SEA'
                  }, null, 8, ["checked"]), [
                    [_vModelRadio, _ctx.fishingGram.fishing_place_type]
                  ]),
                  _hoisted_65
                ]),
                _createVNode("label", _hoisted_66, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    id: 'FISHING_PLACE_TYPE_WATER',
                    name: 'FISHING_PLACE_TYPE',
                    value: 'WATER',
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.fishingGram.fishing_place_type = $event)),
                    checked: _ctx.fishingGram.fishing_place_type === 'WATER'
                  }, null, 8, ["checked"]), [
                    [_vModelRadio, _ctx.fishingGram.fishing_place_type]
                  ]),
                  _hoisted_67
                ])
              ])
            ]),
            _createVNode("div", _hoisted_68, [
              _hoisted_69,
              _createVNode("div", _hoisted_70, [
                _createVNode("label", _hoisted_71, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: 'USER_PERFERRED_TYPE_SEA',
                    name: 'USER_PERFERRED_TYPE_SEA',
                    value: 'SEA',
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fishingGram.preferred_type = $event)),
                    disabled: ""
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.fishingGram.preferred_type]
                  ]),
                  _hoisted_72
                ]),
                _createVNode("label", _hoisted_73, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: 'USER_PERFERRED_TYPE_WATER',
                    name: 'USER_PERFERRED_TYPE_WATER',
                    value: 'WATER',
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fishingGram.preferred_type = $event)),
                    disabled: ""
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.fishingGram.preferred_type]
                  ]),
                  _hoisted_74
                ])
              ])
            ]),
            _createVNode("div", _hoisted_75, [
              _hoisted_76,
              _createVNode("div", _hoisted_77, [
                _createVNode("p", null, _toDisplayString(_ctx.fishingGram.location.address), 1),
                _createVNode("p", null, [
                  _createVNode("a", {
                    href: 
                      `http://maps.google.com/maps?&z=18.5&q=${_ctx.fishingGram.location.coordinates[1]},${_ctx.fishingGram.location.coordinates[0]}`
                    ,
                    target: "_blank"
                  }, " 바로가기 ", 8, ["href"])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_78
      ], 32)
    ])
  ], 2))
}